import React from 'react';
import logo from '../../assets/img/icons/logo.png';
import energoplastLogo from "../../assets/img/icons/energoplast.png"; // Dark theme logo
import classNames from 'classnames';
import { useAppContext } from '../../providers/AppProvider';
import energoplastLogoWhite from "../../assets/img/icons/LogoAlbCuScris.png"; // Light theme logo
import engLogoGri from "../../assets/img/energoplastGri30.png"


const Logo = ({ width = 270, text = true, textClass, className }) => {

  const {
    config: { theme },
  } = useAppContext();

  // Choose the logo based on the theme
  const logoSrc = theme === 'dark' ? energoplastLogoWhite: energoplastLogo ;

  return (
    <div className={classNames(className, 'd-flex align-items-center')} >
      <img src={logoSrc} alt="phoenix" width={250} />
      {text && (
        <p className={classNames(textClass, 'logo-text ms-2')}>phoenix</p>
      )}
    </div>
  );
};

export default Logo;